<template>
    <div class="success-page">
        <div class="success-panel">
            <div class="success-icon">✓</div>
            <h2>
                {{ $i18n.t("subscription.pay_succeed_page_title") }}
            </h2>
            <p class="thank-txt">
                {{ $i18n.t("subscription.pay_succeed_page_stripe_thanks") }}
            </p>
            <div style="display: flex; justify-content: center; margin-top: 20px; gap: 20px;">
                <button class="confirm-btn" @click="close">
                    {{ $i18n.t("subscription.pay_succeed_page_btn_close_current_page") }}
                </button>
                <button class="confirm-btn-right" @click="goToSubscriptions">
                    {{ $i18n.t("subscription.pay_succeed_page_btn_go_to_subscription") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { i18n } from "@/plugins/i18n.js";
import { wdConfigData } from "@/service/wd_app_config.js";
export default {
    name: 'PaymentSuccessPage',
    methods: {
        close() {
            window.close();
        },
        goToSubscriptions() {
            const targetURL = "https://nextmind.yipinapp.com/nextmind-web-ac/#/";
            window.location.href = targetURL;
        }
    },
    mounted(){
        i18n.locale = wdConfigData.localLanguage
    }
}
</script>

<style scoped>
.success-panel {
    text-align: center;
    background: white;
    border-radius: 15px;
    padding: 50px 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.success-icon {
    font-size: 35px;
    color: #27ae60;
    margin-bottom: 20px;
}

.thank-txt {
    font-size: 16px;
    color: #555;
    margin-top: 8px;
    margin-bottom: 18px;
}

.confirm-btn {
    width: 100%;
    background: linear-gradient(45deg, #27ae60, #2ecc71);
    color: white;
    border: none;
    padding: 15px 30px;
    border-radius: 25px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s;
    margin-top: 15px;
}

.confirm-btn-right {
    width: 100%;
    background: linear-gradient(45deg, #667eea, #764ba2);
    color: white;
    border: none;
    padding: 15px 30px;
    border-radius: 25px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s;
    margin-top: 15px;
}
</style>